import {handleActions, Action} from 'redux-actions';
import {TimelineMarker} from 'VideoAudioQC/Timeline/TimelineTypes';
import {
    AccuratePlayerPayload,
    PLAYER_STATUS_SET,
    AdPreviewPayload,
    AD_PREVIEWS_SET,
    SHOW_HOTKEY_DIALOG,
    ShowHotkeysPayload,
    AD_ON_PLAYING_FRAME_SET,
    AdOnPlayingFramePayload,
    ShowSafeMarginsPayload,
    SHOW_SAFE_MARGINS,
} from './AccuratePlayerActions';
import {AdPreview} from '../AccuratePlayerTypes';

export interface AccuratePlayerState {
    paused: boolean;
    volume: number;
    muted: boolean;
    currentTime: number;
    adPreviews?: AdPreview[];
    showHotkeys: boolean;
    adOnPlayingFrame?: TimelineMarker;
    showSafeMargins: boolean;
}

export const setPlayerStatus = (state: AccuratePlayerState, action: Action<AccuratePlayerPayload>): AccuratePlayerState => {
    const {payload} = action;
    const {playerStatus} = payload;
    
    if (playerStatus) {
        const {
            paused,
            volume,
            muted,
            currentTime,
        } = playerStatus;
        const volumeMuted = muted || volume === 0;
        
        return {
            ...state,
            paused,
            volume,
            muted: volumeMuted,
            currentTime,
        };
    }
    return state;
};

export const setPreviewAds = (state: AccuratePlayerState, action: Action<AdPreviewPayload>): AccuratePlayerState => {
    const {payload} = action;
    const {adPreviews} = payload;
    
    return {
        ...state,
        adPreviews,
    };
};

export const setShowHotkeys = (state: AccuratePlayerState, action: Action<ShowHotkeysPayload>): AccuratePlayerState => {
    const {payload} = action;
    const {showHotkeys} = payload;
    
    return {
        ...state,
        showHotkeys,
    };
};

export const setAdOnPlayingFrame = (state: AccuratePlayerState, action: Action<AdOnPlayingFramePayload>): AccuratePlayerState => {
    const {payload} = action;
    const adOnPlayingFrame = payload;
    
    return {
        ...state,
        adOnPlayingFrame,
    };
};

export const setShowSafeMargins = (state: AccuratePlayerState, action: Action<ShowSafeMarginsPayload>): AccuratePlayerState => {
    const {payload} = action;
    const {showSafeMargins} = payload;
    
    return {
        ...state,
        showSafeMargins,
    };
};

export const initialState: AccuratePlayerState = {
    paused: true,
    currentTime: 0,
    volume: 0.5,
    muted: false,
    showHotkeys: false,
    showSafeMargins: false,
};

const handlers = {
    [PLAYER_STATUS_SET]: setPlayerStatus,
    [AD_PREVIEWS_SET]: setPreviewAds,
    [SHOW_HOTKEY_DIALOG]: setShowHotkeys,
    [AD_ON_PLAYING_FRAME_SET]: setAdOnPlayingFrame,
    [SHOW_SAFE_MARGINS]: setShowSafeMargins,
};

export default handleActions<AccuratePlayerState, any>(handlers, initialState);
